import { forwardRef, ReactNode } from 'react';

import { SxProps, Theme } from '@mui/material/styles';
import { styled, useThemeProps } from '@mui/material/styles';

export interface GratiActionBarContainerProps {
  children?: ReactNode;
  position?: 'top' | 'bottom';
  sx?: SxProps<Theme>;
}

interface GratiActionBarContainerOwnerState {
  position: 'top' | 'bottom';
}

const GratiActionBarContainerRoot = styled('div', {
  name: 'GratiActionBarContainer',
  slot: 'root',
  overridesResolver: (_props, styles) => {
    return styles.root;
  },
})<{ ownerState: GratiActionBarContainerOwnerState }>(() => ({}));

const GratiActionBarContainer = forwardRef<HTMLDivElement, GratiActionBarContainerProps>(
  function GratiActionBarContainer(inProps, ref) {
    const props = useThemeProps({ props: inProps, name: 'GratiActionBarContainer' });
    const { children, position = 'bottom', sx } = props;

    // Don't render if no children
    if (!children) return null;

    const ownerState: GratiActionBarContainerOwnerState = { position };

    return (
      <GratiActionBarContainerRoot ref={ref} ownerState={ownerState} sx={sx}>
        {children}
      </GratiActionBarContainerRoot>
    );
  }
);

GratiActionBarContainer.displayName = 'GratiActionBarContainer';

export default GratiActionBarContainer;
